import HomeIcon from '@mui/icons-material/Home';
import { Drawer, Stack, Typography } from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  RootStyle,
  Container,
  NavBarItem,
  LogoContainer,
  YellowIcon,
} from './NavbarVertical.style';
import {
  ICategoriesProps,
  INavbarVerticalProps,
  INavItemProps,
} from './NavbarVertical.types';
import { LogoSmall } from 'assets';
import { FooterLogoIcon } from 'assets/icons';
import { NAVBAR } from 'config';
import { aiItems, navBarItem } from 'constants/data';
// import * as PATHS from 'constants/paths';
import { useTranslations, useResponsive } from 'hooks';
import useCollapseDrawer from 'hooks/useCollapseDrawer';
import { useGlossary } from 'hooks/useGlossary';
import cssStyles from 'utils/cssStyles';

export default function NavbarVertical({
  isOpenSidebar,
  onCloseSidebar,
  clickGlossary,
  clickAI,
}: INavbarVerticalProps) {
  //hooks
  const theme = useTheme();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const i18n = useTranslations();
  const isDesktop = useResponsive('up', 'lg');
  const {
    isCollapse,
    collapseClick,
    collapseHover,
    onHoverEnter,
    onHoverLeave,
  } = useCollapseDrawer();
  const { reduceGlossary, setTyping } = useGlossary();
  const [hoveredIcon, setHoveredIcon] = useState('');
  //effects
  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
      setTyping(false);
    }
  }, [pathname]);

  //function
  const goToPage = (path: string) => {
    reduceGlossary();
    setTyping(false);
    navigate(path);
  };

  //renders
  const renderBlockNavItem = ({
    items,
  }: // text,
  // color,
  {
    items: INavItemProps[];
    // text: string;
    // color: string;
  }) => {
    const categories: ICategoriesProps = i18n.common.categories;

    return (
      <div
        style={{
          position: 'relative',
        }}
      >
        {items?.map((el, index) => {
          const Icon = el.icon;
          return (
            <NavBarItem
              isCollapse={isCollapse}
              key={`navItem-${index}`}
              active={pathname === el.path && !el.disabled}
              style={{
                marginBottom: 20,
                ...(el.disabled && {
                  cursor: 'default',
                  color: '#454F5B',
                }),
                ...(!isCollapse && { width: '220px' }),
              }}
              onMouseEnter={() => setHoveredIcon(el.label)}
              onMouseLeave={() => setHoveredIcon('')}
            >
              <Typography
                variant="body2"
                onClick={() => !el.disabled && goToPage(el.path)}
              >
                <div
                  style={{
                    width: '32px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Icon
                    color={
                      el.disabled
                        ? theme?.palette.grey[600] //'#454F5B'
                        : el.path === pathname
                        ? '#DCB900'
                        : el.label === hoveredIcon
                        ? theme?.palette.primary.main //400
                        : theme.palette.grey[600] //'#919EAB'
                    }
                    style={{ width: '32px', height: '33px' }}
                  />
                </div>
              </Typography>
              {!isCollapse && (
                <Typography
                  mt={0.5} // to align vertically
                  variant="body2"
                  onClick={() => !el.disabled && goToPage(el.path)}
                  color={
                    el.disabled
                      ? theme.palette.grey[600] //'#454F5B'
                      : el.path === pathname
                      ? theme.palette.grey[600] //'#FFF'
                      : el.label === hoveredIcon
                      ? theme?.palette.primary.main //400
                      : theme.palette.grey[700] //'#919EAB'
                  }
                >
                  {categories[el.ref]}
                </Typography>
              )}
            </NavBarItem>
          );
        })}
      </div>
    );
  };

  const renderContent = (
    <Container isCollapse={isCollapse} id="navbar-fla-vertical">
      <LogoContainer
        isCollapse={isCollapse}
        // onClick={() => navigate(PATHS.DASHBOARD)}
        onClick={() => {
          window.open(`${process.env.REACT_APP_FEDERLEGNOARREDO}`, '_self');
        }}
      >
        <LogoSmall
          color={theme.palette.grey[800]}
          width={45}
          height={45}
          sx={{
            position: 'absolute',
            top: '10px',
            left: '-8px',
            opacity: isCollapse ? 1 : 0,
            transition: isCollapse ? 'all 0.5s 0.2s ease' : 'all 0.0s ease',
          }}
        />

        <FooterLogoIcon
          color={theme.palette.grey[800]}
          style={{
            width: '150px',
            position: 'absolute',
            opacity: !isCollapse ? 1 : 0,
            transition: !isCollapse ? 'all 0.5s 0.2s ease' : 'all 0.0s ease',
          }}
        />
      </LogoContainer>
      <Stack
        sx={{
          marginTop: !isCollapse ? '65px' : '75px',
          width: '100%',
        }}
      >
        {/* HOME DAS */}
        <NavBarItem
          isCollapse={isCollapse}
          active={pathname === ''}
          onClick={() => {
            window.open(`${process.env.REACT_APP_DRUPAL_BASE_URL}`, '_self');
          }}
          onMouseEnter={() => {
            setHoveredIcon('home');
          }}
          onMouseLeave={() => {
            setHoveredIcon('');
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            margin: '0px 0px 20px',
          }}
        >
          <HomeIcon
            sx={{
              width: 32,
              height: 32,
              color:
                hoveredIcon === 'home'
                  ? theme.palette.primary.main
                  : theme.palette.grey[600],
            }}
          />
          {!isCollapse && (
            <Typography
              variant="body2"
              sx={{
                color:
                  hoveredIcon === 'home'
                    ? theme.palette.primary.main
                    : theme.palette.grey[700],
                paddingTop: '3px',
              }}
            >
              Home
            </Typography>
          )}
        </NavBarItem>

        {/* NavBar items */}
        {renderBlockNavItem({
          items: navBarItem.slice(1, 12),
        })}
        {[navBarItem[navBarItem.length - 1]].map((el, index) => {
          const Icon = el.icon;

          return (
            <div key={`yellowItem${index}`}>
              <NavBarItem
                isCollapse={isCollapse}
                active={pathname === el.path}
                onClick={clickGlossary}
                style={{
                  alignItems: 'center',
                  ...(!isCollapse && { width: '220px' }),
                }}
              >
                <div
                  style={{
                    width: '32px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Icon />
                </div>
                {!isCollapse && (
                  <Typography variant="body2">
                    {i18n.common.categories.glossary}
                  </Typography>
                )}
              </NavBarItem>
            </div>
          );
        })}
        {aiItems.map((el, index) => {
          const Icon = el.icon;

          return (
            <div style={{ marginTop: '20px' }} key={`yellowItem${index}`}>
              <NavBarItem
                isCollapse={isCollapse}
                active={pathname === el.path}
                onClick={clickAI}
                style={{ alignItems: 'center' }}
                isAiItem={true}
              >
                <YellowIcon isCollapse={isCollapse}>
                  <Icon color="#fff"></Icon>
                  {!isCollapse && (
                    <Typography
                      variant="body2"
                      marginLeft={'8px'}
                      color={'white'}
                    >
                      {i18n.common.categories.ai}
                    </Typography>
                  )}
                </YellowIcon>
              </NavBarItem>
            </div>
          );
        })}
      </Stack>
    </Container>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse
            ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH
            : NAVBAR.DASHBOARD_WIDTH,
        },
        ...(collapseClick && {
          position: 'absolute',
        }),
      }}
    >
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{ sx: { width: NAVBAR.DASHBOARD_WIDTH } }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          onMouseEnter={onHoverEnter}
          onMouseLeave={onHoverLeave}
          sx={{ zIndex: 99999 }}
          PaperProps={{
            sx: {
              width: NAVBAR.DASHBOARD_WIDTH,
              borderRightStyle: 'dashed',
              bgcolor: 'background.default',
              zIndex: 5000,
              transition: theme =>
                theme.transitions.create('width', {
                  duration: theme.transitions.duration.standard,
                }),
              ...(isCollapse && {
                width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
              }),
              ...(collapseHover && {
                ...cssStyles(theme).bgBlur(),
                boxShadow: '0px 0px 10px black',
              }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
